<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_879')}}</div>
    <div slot="body">
      <a-descriptions :title="$t('scope.text_880')" :column="1">
        <a-descriptions-item :label="$t('scope.text_870')">{{params.data[0].name}}</a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_869')">{{params.data[0].enterprise_name}}</a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_881')">{{$t('scope.text_882', [params.data[0].amount])}}</a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_872')">{{ deepTraversal(params.data[0].address)}}</a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_873')">{{params.data[0].contact}}</a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_874')">{{params.data[0].department}}</a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_875')">{{params.data[0].position}}</a-descriptions-item>
        <a-descriptions-item :label="$t('scope.text_876')">{{(params.data[0].created_at && this.$moment(params.data[0].created_at).format()) || '-'}}</a-descriptions-item>
      </a-descriptions>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{$t('scope.text_883')}}</a-button>
      <a-button @click="handleRefuse">{{$t('scope.text_884')}}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'ApproveReportProjectDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      cityOps: [],
    }
  },
  created () {
    this.fetchCities()
    this.$bus.$on('project:refuseSuccess', () => {
      this.params.refresh()
      this.cancelDialog()
    })
  },
  methods: {
    deepTraversal (val) {
      let desc = ''
      if (val) {
        const valPrefix = val.slice(0, 3)
        this.cityOps.map(item => {
          const itemPrefix = item.value.slice(0, 3)
          if (valPrefix === itemPrefix && item.children && item.children.length) {
            item.children.map(chilItem => {
              if (val === chilItem.value) {
                desc = item.label + chilItem.label
              }
            })
          }
        })
      }
      return desc
    },
    async fetchCities () {
      const { data } = await this.$http.get('/v2/cities?nation_code=CN')
      this.cityOps = data.data
    },
    doApprove (data) {
      return new this.$Manager('projectrecords').performAction({
        action: 'review',
        id: this.params.data[0].id,
        data: data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        await this.doApprove({ status: 'accept' })
        this.loading = false
        this.params.refresh()
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
    async handleRefuse () {
      this.createDialog('ProjectRefuseDialog', {
        data: this.params.data,
        refresh: this.params.refresh,
      })
    },
  },
}
</script>

<style lang="less" scoped>
  ::v-deep {
    .ant-descriptions-item-content {
      vertical-align: middle;
    }
    .imageIcon{
      font-size: 16px;
      cursor: pointer;
      color: #1890ff;
    }
  }
</style>
